import React, { ReactNode, createContext, useState, useCallback } from 'react';

// Make TypeScript happy; we overwrite the initialValue instantly
const initialValue = {
  autoPlayRestricted: false,
  /* istanbul ignore next */
  setAutoPlayRestricted: (_: boolean): void => {
    throw new Error('You have not wrapped your component in an AutoPlayProvider');
  },
  /* istanbul ignore next */
  handleAutoplayError: (_: Error): void => {
    throw new Error('You have not wrapped your component in an AutoPlayProvider');
  },
};
const AutoPlayContext = createContext(initialValue);
const { Provider } = AutoPlayContext;

const AutoPlayProvider = ({ children }: { children: ReactNode }) => {
  const [autoPlayRestricted, setAutoPlayRestricted] = useState(false);

  const handleAutoplayError = useCallback(
    (error: Error) => {
      const { name } = error;
      const safariAutoplayWarning = name === 'AbortError' || name === 'NotSupportedError';
      const chromeOrFirefoxAutoplayWarning = name === 'NotAllowedError';
      /* istanbul ignore else: untested branch of code, please test */
      if (safariAutoplayWarning || chromeOrFirefoxAutoplayWarning) {
        setAutoPlayRestricted(true);
      } else {
        throw error;
      }
    },
    [setAutoPlayRestricted],
  );

  return (
    <Provider
      value={{
        autoPlayRestricted,
        handleAutoplayError,
        setAutoPlayRestricted,
      }}
    >
      {children}
    </Provider>
  );
};

export { AutoPlayContext, AutoPlayProvider };
